export default __webpack_public_path__ + "static/media/khalid-alkhudairi.adc312ae.webp";